import clsx from "clsx";
import NextLink from "next/link";
import { ComponentProps, FC } from "react";

export const Link: FC<ComponentProps<typeof NextLink>> = ({ className, ...props }) => {
  return <NextLink className={clsx(className, "text-link underline")} {...props} />;
};
